import { CircularProgress, Collapse, Fade, Paper, Typography, makeStyles } from '@material-ui/core'
import React from 'react'
import { sectionLoaderStyles } from './sectionLoader.styles'

export interface SectionLoaderProps {
  show: boolean
  message?: string
}

const useStyles = makeStyles(sectionLoaderStyles)

export const SectionLoader: React.FC<SectionLoaderProps> = ({ show, message }) => {
  const classes = useStyles()

  return (
    <Collapse in={show} timeout={{ enter: 400, exit: 250 }} unmountOnExit>
      <div className={classes.root}>
        <Fade in={show} timeout={500}>
          <Paper elevation={1} className={classes.paper}>
            <div className={classes.spinnerWrapper}>
              {/* Track ring */}
              <CircularProgress
                variant="determinate"
                value={100}
                size={56}
                thickness={3}
                className={classes.track}
              />
              {/* Animated ring */}
              <CircularProgress size={56} thickness={3} className={classes.spinner} />
            </div>
            {message && (
              <Typography variant="body2" className={classes.message}>
                {message}
              </Typography>
            )}
          </Paper>
        </Fade>
      </div>
    </Collapse>
  )
}
